/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientAdvanceDirectivesViewModel } from './PatientAdvanceDirectivesViewModel'; 

export function getAdvanceDirectivesOptions(stayId: string, onSuccess?: (result: PatientAdvanceDirectivesViewModel) => void) {
	return queryOptions({
		queryKey: ['advance-directives', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/advancedirectives/queries/getadvancedirectives/' + stayId;
			const resp = await axios.get<PatientAdvanceDirectivesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}